import http from '../../../services/api'
import {
  buildInventoryStockCardQuery,
  type InventoryStockCardParams,
  type InventoryStockCardResponse,
} from '../stockCard'

const apiPath = import.meta.env.VITE_API_PATH

async function getInventoryStockCard(params: InventoryStockCardParams) {
  const query = buildInventoryStockCardQuery(params)

  return await http.get<InventoryStockCardResponse>(`${apiPath}reports/inventory-stock-card?${query}`, {
    errorHandle: false,
    timeout: 30000,
  } as any)
}

export default {
  getInventoryStockCard,
}
